<template>
    <div>
        <h1 style="font-size: 24px; color: black;">应用回收日报</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10" >
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button class="std" type="primary"  @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="dataList"
                      style="width: 100%"
                      border
                      :header-cell-style="{background:'#303133'}"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="项目" prop="appName" align="center"></el-table-column>
                <el-table-column label="日期" align="center">
                    <template slot-scope="scope" >
                        {{formatDate(scope.row.dt,"yyyy-MM-DD")}}
                    </template>
                </el-table-column>
                <el-table-column label="总收入" align="center">
                    <el-table-column  label="收益">
                        <template  slot-scope="scope">
                            {{scope.row.totalRevenue==null?'0.00':scope.row.totalRevenue}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="展示">
                        <template  slot-scope="scope">
                            {{scope.row.totalImpressions==null?'0.00':scope.row.totalImpressions}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="视频" align="center">
                    <el-table-column  label="收益">
                        <template  slot-scope="scope">
                            {{scope.row.rewardedVideoRevenue==null?'0.00':scope.row.rewardedVideoRevenue}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="展示">
                        <template  slot-scope="scope">
                            {{scope.row.rewardedVideoImpressions==null?'0.00':scope.row.rewardedVideoImpressions}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="半屏" align="center">
                    <el-table-column  label="收益">
                        <template  slot-scope="scope">
                            {{scope.row.interstitialRevenue==null?'0.00':scope.row.interstitialRevenue}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="展示">
                        <template  slot-scope="scope">
                            {{scope.row.interstitialImpressions==null?'0.00':scope.row.interstitialImpressions}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="开屏" align="center">
                    <el-table-column  label="收益">
                        <template  slot-scope="scope">
                            {{scope.row.splashRevenue==null?'0.00':scope.row.splashRevenue}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="展示">
                        <template  slot-scope="scope">
                            {{scope.row.splashImpressions==null?'0.00':scope.row.splashImpressions}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="信息流" align="center">
                    <el-table-column  label="收益">
                        <template  slot-scope="scope">
                            {{scope.row.flowRevenue==null?'0.00':scope.row.flowRevenue}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="展示">
                        <template  slot-scope="scope">
                            {{scope.row.flowImpressions==null?'0.00':scope.row.flowImpressions}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="友盟量级" align="center">
                    <el-table-column  label="新增">
                        <template  slot-scope="scope">
                            {{scope.row.newUser==null?'0.00':scope.row.newUser}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="活跃">
                        <template  slot-scope="scope">
                            {{scope.row.activeUser==null?'0.00':scope.row.activeUser}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="次留">
                        <template  slot-scope="scope">
                            {{scope.row.r1==null?'0.00%':(scope.row.r1).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="7留">
                        <template  slot-scope="scope">
                            {{scope.row.r7==null?'0.00%':(scope.row.r7).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="14留">
                        <template  slot-scope="scope">
                            {{scope.row.r14==null?'0.00%':(scope.row.r14).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="30留">
                        <template  slot-scope="scope">
                            {{scope.row.r30==null?'0.00%':(scope.row.r30).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>

            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        searchAppData,
        downloadData
    } from "@/http/outApi";
    import utils from '@/utils';
    export default {
        name: "AppDataReport",
        data(){
            return{
                queryData:{
                    timeDate:['','']
                },
                page: {
                    size: 100,
                    page: 1,
                    totalElements: null
                },
                dataList:[],
                loading:true,
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        // 把选择的第一个日期赋值给一个变量。
                        this.choiceDate = minDate.getTime();
                        // 如何你选择了两个日期了，就把那个变量置空
                        if (maxDate) this.choiceDate = ''
                    },
                    // disabledDate: time => {
                    //     // 如何选择了一个日期
                    //     if (this.choiceDate) {
                    //         console.log(time.getTime(),66,this.choiceDate);
                    //         // 7天的时间戳
                    //         const one = 13 * 24 * 3600 * 1000;
                    //         // 当前日期 - one = 7天之前
                    //         const minTime = this.choiceDate - one;
                    //         // 当前日期 + one = 7天之后
                    //         const maxTime = this.choiceDate + one;
                    //         return (
                    //             time.getTime() < minTime ||
                    //             time.getTime() > maxTime
                    //         )
                    //     }else{
                    //         return false
                    //     }
                    // }
                }
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            exportExcel(){
                let fileName = new Date().toLocaleString() + '应用回收日报.xlsx';
                downloadData(
                    '/report/exportApp',
                    this.queryData,
                    fileName
                )
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.loading = true;
                searchAppData(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.dataList=resp.data.info.list;
                        this.page.totalElements =resp.data.info.total;
                    }
                });
            },
        },
        created () {
            this.queryData.timeDate = [utils.TodayUtil.getWeekAgo(),utils.TodayUtil.getToday()];
            this.query();
        }
    }
</script>

<style scoped>

</style>